import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { setNavPageContext, clearNavPageContext } from 'store/slices/miscSlice'
import { getMockCampaignDetail } from 'pages/Promo/components/CampaignDetail/mock/campaignDetail'
import CampaignDetailHeader from 'pages/Promo/components/CampaignDetail/CampaignDetailHeader'
import OverviewTab from 'pages/Promo/components/CampaignDetail/tabs/OverviewTab'

const campaign = getMockCampaignDetail(0)

export default function DashboardV2() {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setNavPageContext({ eyebrow: 'Active Campaign', title: campaign.title }))
    return () => dispatch(clearNavPageContext())
  }, [dispatch])

  const notReady = () => toast.info('This action is coming soon')

  return (
    <section className="w-full max-w-6xl mx-auto pb-10">
      <CampaignDetailHeader
        campaign={campaign}
        onEdit={notReady}
        onDuplicate={notReady}
        onEndCampaign={notReady}
      />

      <OverviewTab campaign={campaign} />
    </section>
  )
}
